import { jobsClient } from "@/shared/api/clients";
import type { ReportJobStatus } from "../../../shared/interfaces/JobStatus";

/** Shape of GET /jobStatus — the server may send raw pipeline statuses
 *  (STARTED/GENERATING/EXTRACTING) that the registry normalizes to PENDING. */
export interface JobStatusSnapshot {
  jobId: string;
  jobStatus: ReportJobStatus | string;
  reportId?: string;
  progress?: number;
  message?: string;
}

export async function getJobStatus(
  jobId: string,
  signal?: AbortSignal,
): Promise<JobStatusSnapshot> {
  const response = await jobsClient.get("/jobStatus", {
    params: { jobId },
    signal,
  });
  return response.data as JobStatusSnapshot;
}

/** Re-submits an existing (failed) job under the same jobId. */
export async function retryJob(jobId: string): Promise<void> {
  await jobsClient.post("/jobs", { jobId });
}
